import { useEffect, useState } from 'react';
import FloatConfigContainer from '../FloatConfigContainer/FloatConfigContainer';
import FloatConfigHeader from '../FloatConfigContainer/FloatConfigHeader/FloatConfigHeader';
import FloatConfigOption from '../FloatConfigContainer/FloatConfigOption/FloatConfigOption';
import { ConfigOption } from 'services/types';

const Placket = () => {
  const [plackets, setPlackets] = useState<ConfigOption[]>();
  useEffect(() => {
    fetch('data/plackets.json')
      .then((response) => response.json())
      .then((data) => {
        setPlackets(data);
      })
      .catch((error) => {
        console.error('Error fetching plackets:', error);
      });
  }, []);

  return (
    <FloatConfigContainer>
      <FloatConfigHeader />
      <div className="body">
        <div className="list-container">
          {plackets &&
            plackets.length > 0 &&
            plackets.map((fab) => (
              <FloatConfigOption
                key={fab.id}
                item={fab}
                procedure="changePlacket"
                type="placket"
              />
            ))}
        </div>
      </div>
    </FloatConfigContainer>
  );
};

export default Placket;
